window.__skudoMotion=true;
/* skudo-motion.js - reveal sections as they scroll into view.
   The <html> gets .skudo-motion-ready from an inline head script (before paint),
   which enables the hidden initial state in skudo-brand.css. This observer then
   adds .is-in to reveal each element once. Respects prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;
  if (!root.classList.contains('skudo-motion-ready')) root.classList.add('skudo-motion-ready');

  var selector = [
    '.skudo-hero__copy',
    '.skudo-trust__item',
    '.skudo-pain__inner',
    '.skudo-feature',
    '.skudo-faq__item',
    '.skudo-guarantee__item',
    '.skudo-offer'
  ].join(',');

  function reveal(el) { el.classList.add('is-in'); }

  function run() {
    var els = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { reveal(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
